<template>
  <div class="main">
    <img class="p-r-img" :src="cdnUrl + imgUrl" alt="">
    <!-- <div class="detail" v-html="detail.desc"></div> -->
    <div class="p-r-return-button" @click="returnBack">
        <i class="iconfont icon-youjiantou"></i>
        <span class="span">返回首页</span>
    </div>
    <div class="detail" v-show="introLength > 0">
        <div class="p-r-content">
            <div class="p-r-info" :class="clickMore?'':'van-multi-ellipsis--l2'" v-html="detail.jianjie"></div>
            <button class="bottom-btn-more" @click="moreContent" v-show="introLength >= 50">{{clickMore?'收起':'更多'}}</button>
        </div>
    </div>
    <div>
        <van-tabs v-model="tabsActive"
            animated
            :color="tabsColor"
            @change="tabsChange"
            :title-active-color="titleActiveColor"
            :title-inactive-color="titleInactiveColor"
            line-width="100"
            line-height="2">
          <van-tab title="详情介绍" name="detail">
            <cent-details :centDetails="detail" ></cent-details>
          </van-tab>
          <van-tab title="相关资料" name="means" v-if="productMaterial.pdf.length > 0">
            <relevant-product :productMaterial="productMaterial" :id="id" @videoChange="videoChange"></relevant-product>
          </van-tab>
          <van-tab title="解决方案" name="solveDetail" v-if="solutionList.length > 0">
            <solution :solutionList="solutionList"></solution>
          </van-tab>
          <van-tab title="视频资源" name="operVideo" v-if="productMaterial.video.length > 0">
            <relevantVideo :productVideo="productMaterial" :id="id" @videoChange="videoChange"></relevantVideo>
          </van-tab>
        </van-tabs>
    </div>
    <!-- 视频播放 -->
    <video-play ref="videoPlay"></video-play>
     
    <button class="bottom-btn" v-if="detail.buy_link" @click="gotoFrom(detail.buy_link)">分享</button>
  </div>
</template>

<script>
import details from './mixins/details'
import { getProgramme } from '@/api/centrifuge'
import DPlayer from 'dplayer'
import centDetails from "./components/centDetails.vue";
import relevantProduct from './components/relevantProduct'
import solution from './components/solution'
import relevantVideo from './components/relevantVideo.vue'
import videoPlay from '@/components/videoPlay'
export default {
    components:{centDetails,relevantProduct,solution,relevantVideo,videoPlay},
    mixins: [details],
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            detail: '',
            clickMore: false,
            introLength: 0,
            imgUrl: '',
            tabsColor: '#005b9f', // 标签栏背景色
            tabsActive: 'detail', // 标签栏选中的下标
            titleActiveColor: '#005b9f', // 标签栏标题栏选中颜色
            titleInactiveColor: '#9d9d9d', // 标签栏标题默认颜色
            id: '',
            solutionList: [], // 关联的解决方案
        }
    },
    created () {
        let { id } = this.$route.query
        this.id = id
        this.getProDetail(id)
        
    },
    methods: {
        getProDetail(id) {
            getProgramme({id:id}).then((res) => {
                this.detail = res.data
                document.title = res.data.title
                res.data.jianjie? this.introLength = res.data.jianjie.length : 0
                this.imgUrl = JSON.parse(res.data.img_url)[0]
                this.solutionList = res.data.solution // 关联的解决方案
                this.productMaterial.pdf = res.data.pdf || []
                this.productMaterial.video = res.data.video || []
            })
        },
        returnBack() {
            this.$router.push({
                name: 'centrifugeHome'
            })
        },
        videoChange (item) {
            var videoUrl = JSON.parse(item.video_url)
            this.videoUrl = videoUrl[0]
            this.$refs.videoPlay.dplayerOption(`${this.cdnUrl + this.videoUrl}`)
        },
        moreContent () {
            this.clickMore = !this.clickMore
        },
        gotoFrom(url) {
            window.location.href = url
        },
        tabsChange() {

        }
    }
}
</script>

<style lang="scss" >
.main {
    // padding: rem(20);
    // box-sizing: border-box;
    .detail {
        overflow: hidden;
        padding: rem(20);
        box-sizing: border-box;
    }
    .p-r-img{
        width: 100%;
        height: auto;
    }
}
.p-r-return-button{
    position: fixed;
    left: 0;
    top: rem(26);
    width: rem(80);
    height: rem(30);
    border-radius: 0 rem(30) rem(30) 0;
    z-index: 999;
    // background: #6DC6DC;
    background: #6CC5DB;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: rem(12);
    color: #fff;
    .icon-youjiantou{
        transform: rotate(180deg);
    }
    .span{
        margin-left: rem(5);
    }
}
.p-r-content {
    background: #dee5ed;
    padding: rem(10) rem(20) rem(20);
    border-radius: 2px;
    .p-r-info{
        color: #333333;
        font-size: 12px;
        line-height: rem(20);
        word-break: break-word;
    }
    .van-multi-ellipsis--l2{
        transition: all .2s;
    }
}

.bottom-btn-more{
    width: rem(72);
    height: rem(28);
    display: block;
    margin: 0 auto;
    margin-top: rem(20);
    border: 1px solid #2c2c2c;
    font-size: 13px;
    background: none;
    color: #2c2c2c;
    border-radius: 2px;
}
.bottom-btn{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: rem(38);
    display: block;
    margin: 0 auto;
    font-size: rem(12);
    color: #fff;
    background-color: #6DC6DC;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    .icon-youjiantou{
        margin-left: rem(5);
        transform: rotate(90deg);
    }
    .rotate-icon{
            transform: rotate(-90deg);
    }
}
</style>